import gql from 'graphql-tag';
import { editorBlockFragment } from '@/editor/api/graphql/editor-block.fragment';

export const documentQuery = gql`
  query Document($documentId: String!) {
    document(documentId: $documentId) {
      id
      name
      status
      isSigning
      isSigningOrder
      isSelfsign
      type
      tags {
        title
        status
        id
      }
      autoCommentText
      isAutoComment
      value
      contractStartDate
      contractEndDate
      expirationDate
      sendDate
      signDate
      isSigningBiometric
      isSigningInitials
      isSigningForward
      isPrivate
      previewUrl
      externalEditorId
      externalEditorType
      uniqueId
      user {
        email
        firstName
        lastName
        fullName
        id
        thumbUrl
        title
        mobile
      }
      recipients {
        firstName
        lastName
        fullName
        companyName
        companyNumber
        title
        mobile
        email
        thumbUrl
        gender
        role
        roleName
        id
        orderNum
        verifyEid
        verifyLinkedin
        verifyQna
        verifySms
        createdAt
        phone
        note
      }
      video {
        video {
          id
          thumbUrl
          videoUrl
        }
      }
      pages {
        id
        pageType
        pageNum
        pageHeight
        pageWidth
        cropBoxH
        cropBoxW
        video {
          id
          thumbUrl
          videoUrl
          videoType
          videoTitle
        }
        contentLinkBlock {
          buttonText
          description
          id
          thumbUrl
          thumbExtension
          title
          url
        }
        editorBlock {
          ...editorBlockFragment
        }
      }
      manuallySignedPages {
        pageWidth
        pageHeight
        pageNum
        thumbUrl
      }
      documentAttachments {
        id
        restrictAccess
        requireView
        createdAt
        previewUrl
        lastView
        lastUpload
        attachment {
          attachmentType
          attachmentTitle
          attachmentDescription
          attachmentUrl
          attachmentFilename
          attachmentSize
          attachmentSha
          thumbUrl
          published
          library
          hashId
        }
        accessRecipientList {
          id
          firstName
          fullName
          lastName
          roleName
        }
      }
    }
  }
  ${editorBlockFragment}
`;

export const loadDocumentPageQuery = gql`
  query DocumentPage($documentId: String!, $id: String!) {
    documentPage(documentId: $documentId, id: $id) {
      id
      thumbUrl
      pageType
      pageNum
      pageHeight
      pageWidth
      cropBoxH
      cropBoxW
      video {
        id
        thumbUrl
        videoUrl
      }
      contentLinkBlock {
        buttonText
        description
        id
        thumbUrl
        thumbExtension
        title
        url
      }
    }
  }
`;

export const documentTrackingQuery = gql`
  query DocumentTracking($documentId: String!) {
    document(documentId: $documentId) {
      id
      clickTrackings: trackClick {
        recipientId
        contentLinkBlockId
        createdAt
      }
      videoTrackings: trackVideo {
        recipientId
        videoId
        viewTime
        viewDuration
      }
      pageTrackings: trackPage {
        id
        recipientId
        pageNum
        pageTime
      }
      visitTrackings: trackVisit {
        recipientId
        visitTime
      }
    }
  }
`;

export const documentPreviewTokenQuery = gql`
  query previewToken($documentId: String!) {
    previewToken(documentId: $documentId) {
      jwt
      exp
    }
  }
`;

export const pageThumbUrl = gql`
  query DocumentPage($id: String!, $documentId: String!) {
    documentPage(id: $id, documentId: $documentId) {
      id
      thumbUrl
    }
  }
`;
